const theaterModeButtonTemplate = ({accessBtnTheaterMode, theaterModeIndex}) => `<button class="theater-mode-button ui control-button tertiary-button" name="TheaterMode" type="button" title="${accessBtnTheaterMode}" tabindex="${theaterModeIndex}">
   <span class="ui theater-mode-button-glyph"></span>
</button>`;

export default theaterModeButtonTemplate;
